import { useEffect, useRef, useCallback } from 'react'
import styled from 'styled-components'
import Colors from '../../../constants/Colors'
import Pagination from './Pagination'

const Search = ({ fetchOrdersByStatus, searchOrders, triggerSearch, setTriggerSearch, page = 1 }) => {
  const orderIdRef = useRef(null)
  const userNoRef = useRef(null)
  const fullNameRef = useRef(null)

  const search = useCallback(async () => {
    const orderId = orderIdRef.current.value.toUpperCase()
    const userNo = userNoRef.current.value.toUpperCase()
    const fullName = fullNameRef.current.value

    if (orderId || userNo || fullName) {
      const params = new URLSearchParams({
        ...(orderId && { orderId }),
        ...(userNo && { userNo }),
        ...(fullName && { name: fullName }),
        page,
      }).toString()
      searchOrders('SEARCH', params)
    } else {
      fetchOrdersByStatus('OPEN')
    }
  }, [fetchOrdersByStatus, page, searchOrders])

  const handleOnChange = (e) => {
    if (e.code === 'Enter') search()
  }

  useEffect(() => {
    search()
  }, [page])

  useEffect(() => {
    if (triggerSearch) {
      search()
      setTriggerSearch(false)
    }
  }, [search, setTriggerSearch, triggerSearch])

  return (
    <>
      <Container>
        <Input ref={orderIdRef} placeholder="รหัสออเดอร์" onKeyDown={(e) => handleOnChange(e)} isUpper />
        <Input ref={userNoRef} placeholder="รหัสลูกค้า" onKeyDown={(e) => handleOnChange(e)} isUpper />
        <Input ref={fullNameRef} placeholder="ชื่อ-นามสกุล" onKeyDown={(e) => handleOnChange(e)} />

        <SearchButton onClick={search}>ค้นหา</SearchButton>
      </Container>
      <Pagination page={page} paramname="searchpage" />
    </>
  )
}

export default Search
const Container = styled.div`
  display: flex;
  justify-content: space-between;
  height: 50px;
  margin: 10px 0;
`
const Input = styled.input`
  flex: 1;
  padding-left: 5px;
  margin-right: 5px;
  ${({ isUpper }) => isUpper && `text-transform: uppercase`};
`
const SearchButton = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  color: ${Colors.DARK_GREY};
  border: 1px solid ${Colors.DARK_GREY};
  &:hover {
    cursor: pointer;
    color: ${Colors.WHITE};
    background-color: ${Colors.DARK_GREY};
  }
`
